<template>
  <div class="fileExamine">
    <Card>
      <div slot="title" style="font-weight:600">初稿文件审核</div>
      <div>
        <Card dis-hover>
          <span slot="title">审核文件：</span>
          <div slot="extra">
            <Button size="small" type="primary" style="margin:0 10px;" @click="cgFileSelect">上传新文件</Button>
            <input type="file" ref="cgFile" style="display:none" @change="cgFileUpload">
            <Button size="small" type="success" @click="selectUser('CG')">发起审核</Button>
          </div>
          <Table :columns="fileColumns" :data="draftFileList"></Table>
        </Card>
      </div>
      <div style="margin-top:5px;">
        <Collapse>
          <Panel>
            当前流程状态：
            <span style="color:#ff9900" v-if="draftFileHistory.length===0">未发起</span>
            <span style="color:#19be6b" v-else-if="draftFileHistory.length>0&&draftFileHistory[draftFileHistory.length - 1].ActivityShowName==='结束'">已通过</span>
            <span style="color:#ff9900" v-else>审核中</span>
            <div slot="content" style="position:relative" v-if="draftFileHistory.length>0">
              <Steps :current="draftFileFlowStep" direction="vertical">
                <template v-for="item in draftFileHistory">
                  <template v-if="!item.CreatedTime">
                    <Step :title="item.ActivityShowName" content="未接收"></Step>
                  </template>
                  <template v-if="item.CreatedTime && !item.CompletedTime">
                    <Step :title="item.ActivityShowName" content="办理中"></Step>
                  </template>
                  <template v-if="item.CompletedTime">
                    <Step :title="item.ActivityShowName" content="已办理"></Step>
                  </template>
                </template>
              </Steps>
              <div class="flow-wrapper">
                <div class="flow-item" v-for="item in draftFileHistory">
                  <div style="display:inline-block;margin-right:15px;">
                    <div>接收时间：{{item.CreatedTime | formatTime}}</div>
                    <div>办理时间：{{item.CompletedTime | formatTime}}</div>
                  </div>
                  <div style="display:inline-block;">
                    <div>办理人：{{item.RealName}}</div>
                    <div>备注：{{item.Opinion}}</div>
                  </div>
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
    </Card>
    <Card style="margin-top:10px;">
      <div slot="title" style="font-weight:600">发售稿文件审核</div>
      <div>
        <Card dis-hover>
          <span slot="title">审核文件：</span>
          <div slot="extra">
            <Button size="small" type="primary" style="margin:0 10px;" @click="fsFileSelect" :disabled="canSellFile">上传新文件</Button>
            <input type="file" ref="fsFile" style="display:none" @change="fsFileUpload">
            <Button size="small" type="success" @click="selectUser('FS')" :disabled="canSellFile">发起审核</Button>
          </div>
          <Table :columns="fileColumns" :data="sellFileList"></Table>
        </Card>
      </div>
      <div style="margin-top:5px;">
        <Collapse>
          <Panel>
            当前流程状态：
            <span style="color:#ff9900" v-if="sellFileHistory.length===0">未发起</span>
            <span style="color:#19be6b" v-else-if="sellFileHistory.length>0&&sellFileHistory[sellFileHistory.length - 1].ActivityShowName==='结束'">已通过</span>
            <span style="color:#ff9900" v-else>审核中</span>
            <div slot="content" style="position:relative" v-if="sellFileHistory.length>0">
              <Steps :current="sellFileFlowStep" direction="vertical">
                <template v-for="item in sellFileHistory">
                  <template v-if="!item.CreatedTime">
                    <Step :title="item.ActivityShowName" content="未接收"></Step>
                  </template>
                  <template v-if="item.CreatedTime && !item.CompletedTime">
                    <Step :title="item.ActivityShowName" content="办理中"></Step>
                  </template>
                  <template v-if="item.CompletedTime">
                    <Step :title="item.ActivityShowName" content="已办理"></Step>
                  </template>
                </template>
              </Steps>
              <div class="flow-wrapper">
                <div class="flow-item" v-for="item in sellFileHistory">
                  <div style="display:inline-block;margin-right:15px;">
                    <div>接收时间：{{item.CreatedTime | formatTime}}</div>
                    <div>办理时间：{{item.CompletedTime | formatTime}}</div>
                  </div>
                  <div style="display:inline-block;">
                    <div>办理人：{{item.RealName}}</div>
                    <div>备注：{{item.Opinion}}</div>
                  </div>
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
    </Card>
    <!-- 流程审批方向选择 -->
    <flowBranch
      :visible="branchVisible"
      :branchList="flowBranch"
      @visibleChange="visibleChange"
      @branchChoose="branchChoose"
      branchType="next"
      ref="flowBranch"
    ></flowBranch>
    <Modal title="审核人员选择" v-model="examineVisible" width="700px" :mask-closable="false">
      <PeopleSel :child-msg="selectPropleList" @toparentevent="handlePeopleSelect"></PeopleSel>
      <div slot="footer" class="dialog-footer">
        <Button @click="examineVisible=false">取消</Button>
        <Button type="primary" @click="startFlow">发起</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import PeopleSel from "@/components/workflow/peopleSelect"
import { startWorkflow, getActivityUsers, getFlowHistory } from '@/lib/flow'
import sendMessage from '@/lib/message'
import FlowBranch from '@/components/flow/flowBranch'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import localFile from '@/lib/localFile'
import { isWeiXin } from '@/lib/tool'

export default {
  components: {
    PeopleSel,
    FlowBranch
  },
  props: {
    projectData: {
      type: Object
    }
  },
  data() {
    return {
      fileColumns: [
        {
          title: '文件名',
          key: 'fileName'
        },
        {
          title: '上传人员',
          key: 'uploadPerson',
          width: 100,
        },
        {
          title: '操作',
          width: 130,
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'center'
              }
            }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px'
                  },
                  on: {
                    click: () => {
                      this.viewUploadFile(params.row)
                    }
                  }
                }, '查看'),
                // h('Button', {
                //   props: {
                //     type: 'error',
                //     size: 'small'
                //   },
                // }, '删除'),
              ])
          }
        }
      ],
      draftFileList: [],
      sellFileList: [],
      selectPropleList: [],
      examineVisible: false,
      selectType: '', // 记录发起类型
      selectedPeople: '', // 记录下一步流程选择人员
      sellFileHistory: [], // 发售稿流程历史
      draftFileHistory: [], // 初稿流程历史,
      messageParams: {
        appId: '1005',
        uniqueId: '',
        contentJson: {
          title: '审核',
          subTitle: '消息',
          description: '项目文件等待审核',
          url: 'http://qy.chinapsp.cn:8884?qyLogin#/userCenter/auditingFile'
        }
      },
      branchVisible: false,
      flowBranch: []
    }
  },
  computed: {
    username () {
      return this.$store.state.session.user.name
    },
    userPhone () {
      return this.$store.state.session.user.phoneNumber
    },
    sellFileFlowStep() {
      if (this.sellFileHistory.length === 0) {
        return 0
      }
      if (this.sellFileHistory[this.sellFileHistory.length - 1].ActivityShowName === '结束') {
        return this.sellFileHistory.length
      }
      return this.sellFileHistory.length - 1
    },
    draftFileFlowStep() {
      if (this.draftFileHistory.length === 0) {
        return 0
      }
      if (this.draftFileHistory[this.draftFileHistory.length - 1].ActivityShowName === '结束') {
        return this.draftFileHistory.length
      }
      return this.draftFileHistory.length - 1
    },
    canSellFile() {
      if (this.draftFileHistory.length > 0 && this.draftFileHistory[this.draftFileHistory.length - 1].ActivityShowName === '结束') {
        return false
      }
      return true
    }
  },
  methods: {
    // 查看下载文件
    async viewUploadFile(file) {
      // window.open(`http://oa.chinapsp.cn:8088/FileModule/Gdfile/downFile?id=${file.id}&name=${this.username}`)
      // const blobUrl = await localFile.downLoadBlob(file.fileGuid)
      // localFile.currentLoad(blobUrl, file.fileName)
      localFile.directLoadFile(file.fileGuid, file.fileName, file.fileSuffix)
    },
    // 获取文件
    getUploadFile(fl) {
      return new Promise(async (resolve, reject) => {
        // let rep = await axios.post(`http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpGetFileList?npid=${this.projectData.id}&fl=${fl}`)
        const params = {
          filter: `fileTypeId=="${fl}" and projectId=="${this.projectData.id}"`
        }
        let rep = await ajax.get(requestUrls.clfile.getList, { params })
        
        if (fl === 32) {
          this.sellFileList = rep.data.result
        }
        if (fl === 2) {
          this.draftFileList = rep.data.result
        }
        resolve(rep.data.result)
      })
    },
    cgFileSelect() {
      // 限制进入4.0立项
			if (this.projectData.dataSource === '4.0立项') {
				this.$Modal.confirm({
					title: '温馨提示',
					content: '文件编制功能已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
					cancelText: '取消',
					okText: '立即前往',
					onOk: () => {
						if (isWeiXin()) {
							window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
						} else {
							window.open('https://qy.choicelink.cn:8440')
						}
					}
				})
				return
			}
      this.$refs.cgFile.click()
    },
    async cgFileUpload() {
      this.$Spin.show()
      try {
        // 添加流程ID给文件
        let flowId = ''
        if (this.draftFileList.length > 0) {
          flowId = this.draftFileList[0]['fileGuid']
          if (this.draftFileList[0]['flowId']) {
            flowId = this.draftFileList[0]['flowId']
          }
        }
        // let formData = new FormData()
        // formData.append('fileToUpload', this.$refs.cgFile.files[0])
        // formData.append('username', this.username)
        // formData.append('fl', '2')
        // formData.append('fileclass', '审查过程文件')
        // formData.append('npid', this.projectData.id)
        // formData.append('wiid', flowId)
        // let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpUpload', formData)

        // 上传文件
        let fileRep = await localFile.uploadFile(this.$refs.cgFile.files[0])

        if (!fileRep || !fileRep.serviceGuid) {
          throw 'uploadError'
        }

        // 提交记录
        const params = {
          projectId: this.projectData.id,
          fileName: fileRep.fileName,
          fileGuid: fileRep.serviceGuid,
          fileSuffix: fileRep.extension,
          fileTypeId: '2',
          uploadPerson: this.username,
          fileTypeName: '审查过程文件',
          flowId: flowId
        }
        let recordRep = await localFile.createFileRecord(params)

        if (!recordRep) {
          throw 'RecordError'
        }

        this.$Spin.hide()
        this.$refs.cgFile.value = ''

        this.$Message.success('上传成功')
        this.getUploadFile(2)
        
      } catch (err) {
        this.$refs.cgFile.value = ''
        this.$Spin.hide()
        this.$Message.error('上传失败')
      }
    },
    fsFileSelect() {
      // 限制进入4.0立项
			if (this.projectData.dataSource === '4.0立项') {
				this.$Modal.confirm({
					title: '温馨提示',
					content: '文件编制功能已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
					cancelText: '取消',
					okText: '立即前往',
					onOk: () => {
						if (isWeiXin()) {
							window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
						} else {
							window.open('https://qy.choicelink.cn:8440')
						}
					}
				})
				return
			}
      this.$refs.fsFile.click()
    },
    async fsFileUpload() {
      this.$Spin.show()
      try {
        // 添加流程ID给文件
        let flowId = ''
        if (this.sellFileList.length > 0) {
          flowId = this.sellFileList[0]['fileGuid']
          if (this.sellFileList[0]['flowId']) {
            flowId = this.sellFileList[0]['flowId']
          }
        }
        // let formData = new FormData()
        // formData.append('fileToUpload', this.$refs.fsFile.files[0])
        // formData.append('username', this.username)
        // formData.append('fl', '32')
        // formData.append('fileclass', '招标文件发售稿')
        // formData.append('npid', this.projectData.id)
        // formData.append('wiid', flowId)
        // let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpUpload', formData)

        // 上传文件
        let fileRep = await localFile.uploadFile(this.$refs.fsFile.files[0])

        if (!fileRep || !fileRep.serviceGuid) {
          throw 'uploadError'
        }

        // 提交记录
        const params = {
          projectId: this.projectData.id,
          fileName: fileRep.fileName,
          fileGuid: fileRep.serviceGuid,
          fileSuffix: fileRep.extension,
          fileTypeId: '32',
          uploadPerson: this.username,
          fileTypeName: '招标文件发售稿',
          flowId: flowId
        }
        let recordRep = await localFile.createFileRecord(params)

        if (!recordRep) {
          throw 'RecordError'
        }

        this.$Spin.hide()
        this.$refs.fsFile.value = ''
        
        this.$Message.success('上传成功')
        this.getUploadFile(32)

      } catch (err) {
        this.$refs.fsFile.value = ''
        this.$Spin.hide()
        this.$Message.error('上传失败')
      }
    },
    selectUser(type) {
      // 限制进入4.0立项
			if (this.projectData.dataSource === '4.0立项') {
				this.$Modal.confirm({
					title: '温馨提示',
					content: '文件编制功能已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
					cancelText: '取消',
					okText: '立即前往',
					onOk: () => {
						if (isWeiXin()) {
							window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
						} else {
							window.open('https://qy.choicelink.cn:8440')
						}
					}
				})
				return
			}
      if (type === 'CG') {
        if (this.draftFileList.length === 0) {
          this.$Message.error('请先上传初稿')
          return
        }
        if (this.draftFileHistory.length > 0) {
          this.$Message.error('请勿重复发起')
          return
        }
      }
      if (type === 'FS') {
        if (this.draftFileList.length === 0 || this.draftFileHistory.length === 0) {
          this.$Message.error('请先进行初稿审核')
          return
        }
        if (this.sellFileList.length === 0) {
          this.$Message.error('请先上传发售稿')
          return
        }
        if (this.sellFileHistory.length > 0) {
          this.$Message.error('请勿重复发起')
          return
        }
      }
      this.$Spin.show()
      this.selectType = type
      getActivityUsers({ appId: type, userPhone: this.userPhone }).then(
        res => {
          this.$Spin.hide()
          this.flowBranch = res
          this.selectPropleList = res[0]
          this.branchVisible = true
        },
        err => {
          this.$Spin.hide()
          console.error(err)
          this.$Message.error('获取人员失败')
        }
      )
    },
    // 发起流程
    startFlow() {
      if (this.selectedPeople === '') {
        this.$Message.error('请先选择流程人员')
        return
      }
      let wiid = ''
      let fileName = ''
      // 以第一个文件GUID为流程wiid
      if (this.selectType === 'FS') {
        wiid = this.sellFileList[0]['fileGuid']
        fileName = this.sellFileList[0]['fileName']
      }
      if (this.selectType === 'CG') {
        wiid = this.draftFileList[0]['fileGuid']
        fileName = this.draftFileList[0]['fileName']
      }
      let thisUser = {
        appId: this.selectType,
        userPhone: this.userPhone,
        wiid: wiid,
        flowTitle: this.projectData.projectName,
        businessKey: this.projectData.id,
        opinion: this.$refs.flowBranch.opinion
      }
      let nextUser = {
        nextActivityCode: this.selectPropleList.NextActivityCode,
        userId: this.selectedPeople.userId
      }
      this.$Spin.show()
      startWorkflow(thisUser, nextUser).then(
        res => {
          this.$Spin.hide()
          this.$Message.success('发起成功')
          if (this.selectType === 'FS') {
            this.getFlowHistory(wiid, 32)
            this.messageParams.contentJson.subTitle = '发售稿审核'
          }
          if (this.selectType === 'CG') {
            this.getFlowHistory(wiid, 2)
            this.messageParams.contentJson.subTitle = '初稿审核'
          }

          // 企业微信发送审核信息
          this.messageParams.uniqueId = this.selectedPeople.userName
          this.messageParams.contentJson.title = this.projectData.projectName
          sendMessage('wechat', this.messageParams)

          this.examineVisible = false
          // 清空流程人员
          this.selectedPeople = ''
        },
        err => {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('发起失败')
        }
      )
    },
    // 获取流程历史
    getFlowHistory(wiid, fl) {
      this.$Spin.show()
      getFlowHistory(this.userPhone, wiid).then(
        res => {
          if (fl === 32) {
            this.sellFileHistory = res
          }
          if (fl === 2) {
            this.draftFileHistory = res
          }
        },
        err => {
          console.error(err)
        }
      ).finally(() => {
        this.$Spin.hide()
      })
    },
    handlePeopleSelect(selectedPeople) {
      this.selectedPeople = selectedPeople
    },
    visibleChange(status) {
      if (!status) {
        this.branchVisible = status
			}
    },
    branchChoose(val) {
      this.branchVisible = false
      this.examineVisible = true
    }
  },
  watch: {
    projectData(val) {
      if (val) {
        this.sellFileHistory = []
        this.draftFileHistory = []
        // 获取审核文件
        this.getUploadFile(32).then(
          res => {
            if (res.length > 0) {
              let wiid = res[0]['fileGuid']
              if (res[0]['flowId']) {
                wiid = res[0]['flowId']
              }
              this.getFlowHistory(wiid, 32)
            }
          }
        )
        this.getUploadFile(2).then(
          res => {
            if (res.length > 0) {
              let wiid = res[0]['fileGuid']
              if (res[0]['flowId']) {
                wiid = res[0]['flowId']
              }
              this.getFlowHistory(wiid, 2)
            }
          }
        )
      }
    },
    sellFileHistory (val) {
      // 修改项目编号发售稿完结
      if (this.sellFileHistory.length > 0 && this.sellFileHistory[this.sellFileHistory.length - 1].ActivityShowName==='结束' && this.projectData.projectState == '标书文件已完成') {
        ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
          id: this.projectData.id,
          projectState: '审查通过可挂网'
        })
      }
    }
  },
  filters: {
    formatTime(time) {
      if (!time) {
        return ''
      }
      let formatTime = new Date(parseInt(time.slice(6, 19)))
      return formatTime.toLocaleString().replace(/\//g, '-')
    }
  }
}
</script>

<style lang="less">
.fileExamine {
  .flow-wrapper {
    position: absolute;
    top: 10px;
    right: 40px;
    .flow-item {
      margin-top: 2.5px;
      height: 61px;
      font-size: 12px;
    }
  }
  .ivu-steps .ivu-steps-main {
    border-bottom: 1px solid #ddd;
  }
}
</style>
